// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const iceberg = defineModel({
  id: "iceberg",
  batchId: "future",
  name: "Iceberg",
  tags: ["scenery","iceberg","low-poly","age-of-mcp","future","water"],
  summary: "A drifting iceberg — polar-ocean scenery and fresh-water ice.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.46,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.34, 0), color: "#a7cfe0", position: [0, 0.34, 0], rotation: [0.1, 0.4, 0.12], scale: [1, 1.25, 0.9] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: "#8fbcd1", position: [0.2, 0.26, 0.08], rotation: [0.2, 1.1, 0.1], scale: [1, 1.3, 0.85] },
      { geometry: new THREE.TetrahedronGeometry(0.18, 0), color: "#c2e2ef", position: [-0.12, 0.4, 0.16], rotation: [0.4, 0.6, 0.3] },
      { geometry: new THREE.TetrahedronGeometry(0.13, 0), color: "#c2e2ef", position: [0.1, 0.52, -0.06], rotation: [0.2, 1.4, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.16, 0), color: "#eef6fb", position: [-0.02, 0.62, 0], rotation: [0.1, 0.3, 0], scale: [1.1, 0.7, 1.1] },
      { geometry: new THREE.TetrahedronGeometry(0.1, 0), color: "#eef6fb", position: [0.16, 0.5, 0.1], rotation: [0.3, 0.8, 0.1] },
      { geometry: new THREE.CylinderGeometry(0.4, 0.34, 0.06, 7), color: "#bfe0ec", position: [0, 0.03, 0], rotation: [0, 0.5, 0], scale: [1.15, 1, 0.95] },
      { geometry: new THREE.IcosahedronGeometry(0.1, 0), color: "#8fbcd1", position: [0.36, 0.06, -0.2], rotation: [0.3, 0.7, 0.2], scale: [1, 0.8, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.05, 0), color: "#eef6fb", position: [0.36, 0.13, -0.2], rotation: [0.2, 0.5, 0.3] },
    ],
  animations: [],
});
